module.exports = {
    "clickableColumn": "mc5df48f8c_clickableColumn",
    "clickableRow": "mc5df48f8c_clickableRow"
};